import { theme } from '../styles/theme';

// Reduz a imagem antes do envio: cabe em ladoMaximo px e vira JPEG.
// Faz no navegador o que o gm.exe faz no ERP desktop (a API não reduz) e converte
// formatos que a API não aceita (webp, por exemplo) para jpg.

function carregarImagem(arquivo: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(arquivo);
    const imagem = new Image();
    imagem.onload = () => {
      URL.revokeObjectURL(url);
      resolve(imagem);
    };
    imagem.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error(`Formato de imagem não suportado: ${arquivo.name}`));
    };
    imagem.src = url;
  });
}

export async function reduzirImagem(arquivo: File, ladoMaximo = 1200, qualidade = 0.85): Promise<{ blob: Blob; nome: string }> {
  const imagem = await carregarImagem(arquivo);

  const escala = Math.min(1, ladoMaximo / Math.max(imagem.naturalWidth, imagem.naturalHeight));
  const largura = Math.round(imagem.naturalWidth * escala);
  const altura = Math.round(imagem.naturalHeight * escala);

  const canvas = document.createElement('canvas');
  canvas.width = largura;
  canvas.height = altura;
  const contexto = canvas.getContext('2d');
  if (!contexto) throw new Error('Não foi possível processar a imagem');

  // PNG transparente: fundo branco, já que o JPEG não tem transparência
  contexto.fillStyle = theme.cores.card;
  contexto.fillRect(0, 0, largura, altura);
  contexto.drawImage(imagem, 0, 0, largura, altura);

  const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve, 'image/jpeg', qualidade));
  if (!blob) throw new Error('Não foi possível processar a imagem');

  const nome = `${arquivo.name.replace(/\.[^.]+$/, '') || 'foto'}.jpg`;
  return { blob, nome };
}
